import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_BUSINESS, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 120000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      const token = localStorage.getItem('token')
      config.headers.Authorization = `Bearer ${token}`
    }

    if (store.getters.currentRole) {
      config.headers.CurrentRole = `${escape(store.getters.currentRole)}`
    }

    config.headers.brandCode = `${store.getters.config.brandCode}`

    const timeStamp = new Date().getTime()
    config.url.indexOf('?') === -1 ? config.url = config.url + '?t=' + timeStamp : config.url = config.url + '&t=' + timeStamp

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.request && response.request.responseType.toLowerCase() === 'blob') {
      return response
    }

    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code && res.code !== 1) {
      Message({
        type: 'error',
        message: res.message || res.msg || 'Error',
        duration: 5000
      })

      if(res.code === 210) {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      return Promise.reject(new Error(res.message || res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      Message({
        type: 'warning',
        message: '登录已失效, 请重新登录.',
        duration: 3000
      })
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
      return
    } else {
      console.log('err' + error) // for debug
      Message({
        type: 'error',
        message: error.message || error.msg,
        duration: 3000
      })
    }
    return Promise.reject(error)
  }
)

export default service
